import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from '@angular/core';

@Component({
  selector: 'app-copyright',
  standalone: true,
  template: `<p>
    Copyright © {{ currentYear() }}
    @if (showBrand()) {
      <span class="font-normal"> - FNE</span>
    }
  </p>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCopyrightComponent {
  readonly currentYear = signal(new Date().getFullYear());
  readonly showBrand = input<boolean>(true);
}
